import { ReactNode, Suspense } from 'react';

import { NsxHeader } from 'components/common/nsx-header/NsxHeader';
import { AuthProvider } from 'components/common/auth-provider/AuthProvider';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

type Route = {
  hasFooter?: boolean;
  requiresLogin?: boolean;
  noIndex?: boolean;
  name: string;
};

type RouteScreenProps = {
  route: Route;
  children?: ReactNode;
  isLoginEnabled?: boolean;
};

export const RouteScreen = (props: RouteScreenProps) => {
  const {
    route: { hasFooter, requiresLogin, noIndex },
    children,
    isLoginEnabled
  } = props;
  const authEnabled = requiresLogin && isLoginEnabled;

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <AuthProvider enabled={authEnabled}>
        <NsxHeader route={props.route} />
        <main id="#content">
          <Suspense fallback={<NsStopgap />}>{children}</Suspense>
        </main>
        {hasFooter && <nsx-footer />}
      </AuthProvider>
    </>
  );
};
